// @ts-check
import React, { useState } from 'react'
import styles from './style.css'

/**
 * @param {{ text: string, className?: string }} props
 */
const InfoIcon = ({ text, className }) => {
  const [isShown, setIsShown] = useState(false)

  const show = () => setIsShown(true)

  const hide = () => setIsShown(false)

  const isTextShownClass = isShown ? styles.show : ''
  return (
    <div className={`${styles.container} ${isTextShownClass} ${className}`}>
      <div
        className={styles.header}
        onMouseEnter={show}
        onMouseLeave={hide}
        onClick={show}
      >
        ?
      </div>
      <div className={styles.text}>{text}</div>
    </div>)
}

export { InfoIcon }
